module.exports = __webpack_public_path__ + "img/cases-brand-hla-13.e2851a00.png";